// ErrorMessage.jsx

import React from 'react';

const ErrorMessage = ({ title, message }) => {
  return (
    <div className="error-message-container">
      <div className="error-message-content">
        <h2 className="error-title">{title}</h2>
        <p className="error-description">{message}</p>
      </div>
    </div>
  );
};

export default ErrorMessage;